import React from 'react'
import { ChannelContextProvider } from '../../context';
import ChannelScreenView from './ChannelScreenView';

const ChannelView = () => {
  return (
    <ChannelContextProvider>
      <ChannelScreenView />
    </ChannelContextProvider>
  )
}

export default ChannelView